/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-15 15:09:00
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import VideoApi, { VideoDOI } from './api/videoApi';
 import { Integer } from 'src/types/base';
 import { createNamespace } from 'src/util/bem';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumSex from 'src/enums/enumSex';
 import EnumCloud  from 'src/enums/EnumCloud';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import EnumOperates from 'src/enums/enumOperates';
 import RegexCheck from 'src/util/regexCheck';
 import IconCustom from 'src/components/icon/iconCustom';
 
 export namespace OperateVideoDOI {
     export interface PropsI {
         operate: string;
         id?: number;
 
         saveSuccess?(): void;
 
         cancel?(): void;
     }
 
     export interface FormDataI {
        id?: number
        name: string
        phone: string
        type: number
        appkey:string
        secret:string
     }
 }
 
 @Component
 class OperateVideoModal extends Vue.Component<OperateVideoDOI.PropsI> {
     @Prop({
         type: Function,
     })
     cancel!: () => void;
 
     @Prop({
         type: Number,
     })
     id!: number;
 
     @Prop({
         type: String,
     })
     operate!: string;
 
     @Prop({
         type: Function,
     })
     saveSuccess!: () => void;
 
     visible: boolean = false;
 
     loading: boolean = false;
 
     formData: OperateVideoDOI.FormDataI = {
        name: '',
        phone: '',
        type: null,
        appkey:'',
        secret:''
     };
     rules: any = {
     };
 
     close() {
         this.cancel && this.cancel();
         this.closeModal();
     }
 
     closeModal() {
         this.visible = false;
         this.$emit('close', false);
     }
 
     async save() {
         if (!(await this.$validate('formValidate'))) {
             return;
         }
         let res;
         this.loading = true;
         let params: OperateVideoDOI.OperateParamsI = {
             ...this.formData
         };
         switch (this.operate) {
             case EnumOperates.Add.getName():
                 res = await VideoApi.add(params);
                 break;
             case EnumOperates.Update.getName():
                 params.user_id = this.id;
                 res = await VideoApi.update(params);
                 break;
         }
         this.loading = false;
         let { code } = res;
         if (code === 0) {
             Toast.success(this.operate + '成功');
             this.saveSuccess();
             this.closeModal();
         }
     }
     created() {
         let t = this;
     }
     async mounted() {
         if (this.operate !== EnumOperates.Add.getName()) {
             let { code, data } = await VideoApi.searchDetail(this.id);
             if (code === 0) {
                 this.formData = {
                    ...data[0],
                 };
             }
         }
     }
     render(h) {
         return (
             <Modal
                 class={createNamespace('modal')}
                 title={'视频密钥'+this.operate}
                 width="800"
                 v-model={this.visible}
                 mask-closable={false}
                 on-on-cancel={this.close}
                 footer-hide={EnumOperates.Detail.getName()===this.operate}
             >
                 <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="云端类型" prop="type" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%" type='number'>
                        <CommonSelect disabled={this.operate === EnumOperates.Detail.getName()} dataSource={EnumCloud.getList()} v-model={this.formData.type} />
                    </form-item>    
                    <form-item label="注册手机号" prop="name" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%">
                         <Input disabled={this.operate === EnumOperates.Detail.getName()} v-model={this.formData.name} placeholder="请输入" />
                     </form-item>
                     <form-item label="AppKey" prop="appkey" required={this.operate !== EnumOperates.Detail.getName()} style="display: inline-block;width:90%">
                         <Input disabled={this.operate === EnumOperates.Detail.getName()} v-model={this.formData.appkey} placeholder="请输入" />
                     </form-item>
                     <form-item label="Secret" prop="secret" required={this.operate !== EnumOperates.Detail.getName()}   style="display: inline-block;width:90%">
                         <Input disabled={this.operate === EnumOperates.Detail.getName()} v-model={this.formData.secret} placeholder="请输入" />
                     </form-item>
                 </i-form>
                 <div slot="footer" v-if={EnumOperates.Detail.getName()!==this.operate}>
                     <Button type="primary" ghost on-click={this.close}>
                         取消
                     </Button>
                     <Button type="primary" on-click={this.save} loading={this.loading}>
                         保存
                     </Button>
                 </div>
             </Modal>
         );
     }
 }
 
 export default function alertOperateVideoModal(operate: string, id?: number): Promise<boolean> {
     return new Promise((resolve, reject) => {
         modalFactory<OperateVideoVOI.PropsI>(OperateVideoModal)({
             id,
             operate,
             saveSuccess() {
                 resolve(true);
             },
             cancel() {
                 resolve(false);
             },
         });
     });
 }
 